<div class="flex-column">
  <!-- Metric name-->
  <div class="flex-row">
    <div class="quarter-of-space text-label" translate="metric-reports/edition/metric"></div>
    <div>{{ report.ui.metricName }}</div>
  </div>
  <!-- Selected criteria -->
  <div class="flex-row selected-criteria-row">
    <div class="quarter-of-space text-label" translate="metric-reports/edition/criteria"></div>
    <div *ngIf="report.ui.filterCriteria.length; else none" class="flex-column selected-criteria-chips">
      <div *ngFor="let criterion of report.ui.filterCriteria">
        <mat-chip-list>
          <mat-chip disableRipple>
            <span class="chip-label">{{ criterion.selectorLabel }}:</span>&nbsp;
            <span class="chip-value" *ngFor="let valueLabel of criterion.valueLabels; last as isLast">
              {{ valueLabel }}<span *ngIf="!isLast">,&nbsp;</span>
            </span>
            <span
              class="chip-value"
              *ngIf="criterion.valueLabels.length === 0"
              translate="metric-reports/edition/details-n-a"></span>
          </mat-chip>
        </mat-chip-list>
      </div>
    </div>
    <ng-template #none>
      <div translate="metric-reports/edition/no-criteria"></div>
    </ng-template>
  </div>
  <!-- Group by-->
  <div *ngIf="report.ui.groupBy" class="flex-row">
    <div class="quarter-of-space text-label" translate="metric-reports/edition/group-by"></div>
    <div>{{ report.ui.groupBy }}</div>
  </div>
  <!-- Created by-->
  <div *ngIf="!isCreation" class="flex-row">
    <div class="quarter-of-space text-label" translate="metric-reports/edition/created-by"></div>
    <div>{{ report.ui.createdBy }}</div>
  </div>
</div>
